import React from "react";
import Breadcrumbs from '../components/Breadcrumbs.jsx';
import PageHead from '../components/PageHead.jsx';
import SubmenuOnPageTop from '../components/SubmenuOnPageTop.jsx';

export const Page = (Component) => {
  class WrappedComponent extends React.Component {
    render() {
      return (
        <>
          <Breadcrumbs />
          <PageHead listCount={this.props.listCount}/>
          <SubmenuOnPageTop/>
          <Component {...this.props} />
        </>
      )
    }
  }
  return WrappedComponent
}
